<template>
  <div class="w-full flex flex-col page-model-detail" v-loading="loading">
    <div class="w-full top px-155px flex mt-0.1rem">
      <div class="flex-1 flex flex-col mb-12px">
        <div class="flex-1 overflow-hidden ml-25px">
        
          <div class="flex mt-20px">
            <span class="text-black text-22px font-bold mr-10px">
              {{ modelInfo.project_name_zh }}
            </span>
            <div
              class="download px-10px h-20px flex items-center justify-center"
            >
              <img
                src="@/assets/images/model/download_white.png"
                class="mr-5px download-img"
              />
              <span class="text-white text-16px">
                {{ modelInfo.project_load_num }}
              </span>
            </div>
          </div>
          <div class="text-16px text-default mt-10px">
            {{ modelInfo.project_name_en }}
            <!-- <i :data-clipboard-text="`git clone ${modelInfo.project_git_url}.git`"
              class="el-icon-document-copy copy-link cursor-pointer mx-10px"></i> -->
            <span class="ml-15px text-black"
              >由
              <span
                class="cursor-pointer w-100px truncate"
                @click="ownerClick"
                >{{ modelInfo.username || '-' }}</span
              >
              提供</span
            >
          </div>
          <div class="project_intro text-black mt-10px">
            {{ modelInfo.project_intro }}
          </div>
          <div class="flex flex-wrap">
            <div
              class="tag text-16px px-12px py-5px mr-15px mt-10px text-pri cursor-pointer"
              v-for="(item, index) in modelInfo.tags"
              :key="index"
              @click="tagClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>

        <el-tabs
          v-model="activeTab"
          class="mt-10px"
          @tab-click="
            goDetail({
              username: modelInfo.username_en,
              engName: modelInfo.project_name_en,
              tab: activeTab
            })
          "
        >
          <el-tab-pane
            :name="item.value"
            v-for="(item, index) in tabs"
            :key="item.value"
          >
            <div slot="label" class="h-full flex justify-center items-center">
              <img :src="item.logo" class="tab-icon" />
              <span class="text-21px font-bold">{{
                index < 2 ? project_type_name + item.name : item.name
              }}</span>

              <el-badge
                :value="modelInfo.issue_count"
                class="item"
                v-if="item.name === '讨论' && modelInfo.issue_count > 0"
              ></el-badge>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="w-500px flex flex-col items-end">
        
        <div class="flex-1 flex mr-40px mt-70px">
          <el-tooltip effect="dark" content="Star" placement="bottom-start">
            <div
              class="like flex flex-col justify-center items-center cursor-pointer mr-11px"
              @click="like"
              v-loading="likeLoading"
            >
              <img
                v-if="modelInfo.has_like == 1"
                src="@/assets/images/has_like.png"
                class="like-icon"
              />
              <img v-else src="@/assets/images/like.png" class="like-icon" />
            </div>
          </el-tooltip>
          <el-button
            class="h-53px common-button hide-x mr-11px"
            style="margin-left: 0"
            v-if="project_type === 'M' || project_type === 'D'"
            @click="newmodeldev"
            >训练或微调</el-button
          >
          <el-button
            class="mr-11px h-53px hide-x"
            style="margin-left: 0"

            type="primary"
            @click="newProject"
            >新建{{ project_type_name }}</el-button
          >
          <!-- <el-button class="mr-11px h-53px hide-x" style="margin-left: 0" type="primary" v-if="project_type === 'M'&&showBushuBtn"
            @click="bushuModel">在线体验</el-button>
            <el-button class="mr-11px h-53px hide-x" style="margin-left: 0" type="primary" v-if="project_type === 'M'&&showBushuBtn"
            @click="bushuAPI">API部署</el-button> -->
          <el-dropdown style="height: 35px" v-if="project_type === 'M' && showBushuBtn || showBushuapiBtn">
            <el-button type="primary" class="mr-11px h-53px hide-x">
              在线部署<i class="el-icon-arrow-down"></i>
            </el-button>
            <el-dropdown-menu
              slot="dropdown"
              style="left: -50px; padding: 10px"
            >
              <el-button
                class="mr-11px h-53px hide-x"
                style="margin: 5px"
                type="primary"
                v-if="project_type === 'M' && showBushuBtn"
                @click="bushuModel"
                >部署在线体验</el-button
              ><br />
              <el-button
                class="mr-11px h-53px hide-x"
                style="margin: 5px"
                type="primary"
                v-if="project_type === 'M' && showBushuapiBtn"
                @click="bushuAPI"
                >部署API 服务</el-button
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip effect="dark" content="收藏" placement="bottom-start">
            <div
              class="like flex flex-col justify-center items-center cursor-pointer"
              @click="collect"
              v-loading="collectLoading"
            >
              <img
                v-if="modelInfo.has_collect == 1"
                src="@/assets/images/has_collect.png"
                class="like-icon"
              />
              <img v-else src="@/assets/images/collect.png" class="like-icon" />
            </div>
          </el-tooltip>
        </div>
        <div class="mr-20px mb-30px hide-x">
          <el-button
            class="mx-15px common-button"
            v-if="modelInfo.is_show_manage===1"
            @click="editPro"
            >修改</el-button
          >
          <!-- 暂时隐藏掉删除按钮 -->
          <el-button
            class="common-button"
            :loading="deleteLoading"
            v-if="false"
            @click="deletePro"
            >删除</el-button
          >
        </div>
      </div>
    </div>
    <div class="flex-1 overflow-hidden" v-if="modelInfo.id">
      <div class="text-0.1rem  " style="color: #333333; width: 84%; margin: auto;">
               <Notice></Notice>
        </div>
      <detail v-if="activeTab === 'intro'" :data="modelInfo" />
      <file   ref='filelist' v-if="activeTab === 'file' || activeTab === 'blob'" :data="modelInfo"/>
      <discuss v-if="activeTab === 'discuss'" :data="modelInfo" />
      <PullRequests v-if="activeTab === 'PullRequests'"></PullRequests>
    </div>
    <!-- 新建项目弹层 -->
    <el-dialog
      :title="`${isEdit ? '修改' : '创建'}${project_type_name}`"
      :visible.sync="newProjectVisible"
      width="7.6rem"
      @close="closeDialog"
    >
      <NewModel
        @finish="newProjectVisibleFinish"
        v-if="project_type === 'M'"
        :edit="isEdit"
        :id="modelInfo.id"
        ref="newModelRef"
      />
      <NewDataset
        @finish="newProjectVisibleFinish"
        v-if="project_type === 'D'"
        :edit="isEdit"
        :id="modelInfo.id"
        ref="newDatasetRef"
      />
      <NewCode
        @finish="newProjectVisibleFinish"
        v-if="project_type === 'C'"
        :edit="isEdit"
        :id="modelInfo.id"
        ref="newCodeRef"
      />
    </el-dialog>
    <!-- 部署模型弹层 -->
    <el-dialog title="部署模型" :visible.sync="bushuModelVisible" width="6rem">
      <deployModel
        @finish="finishFn"
        :checkImg="checkImg"
        :correlation="correlation"
        ref="deployModelt"
      />
    </el-dialog>
    <el-dialog title="API部署" :visible.sync="bushuAPIVisible" width="6rem">
      <deployAPI
        @finish="APIfinishFn"
        :checkImg="checkapiImg"
        :correlation="apicorrelation"
        ref="deployAPI"
      />
    </el-dialog>
    <el-dialog title="创建开发环境" :visible.sync="modelVisible" width="6rem" :before-close="closeModel">
      <newCp ref="newCp"  @finish="modeldevfinish"></newCp>
    </el-dialog>
  </div>
</template>

<script>
import detail from './detail.vue'
import file from './file.vue'
import PullRequests from './pullRequests/index.vue'
import discuss from './discuss/index.vue'
import NewModel from '../new-model'
import deployModel from '../deploy-model/deploy-model'
import deployAPI from '../deploy-model/deploy-API'
import NewDataset from '@/views/dataset/new-dataset'
import NewCode from '@/views/code/new-model'
import getProjectTags from '@/utils/getProjectTags'
import dayjs from 'dayjs'
import Clipboard from 'clipboard'
import justOnceElMessage from '@/utils/justOnceElMessage'
import hasPer from '@/utils/hasPermission'
import { valiUser } from '@/utils/validate'
import newCp from '@/views/cp/newcp.vue'
import Notice from '@/components/noticetemplate.vue'

export default {
  
  // metaInfo() {
  //   return {
  //     meta: [
  //       {
  //         property: 'og:description',
  //         content: this.modelInfo.project_intro
  //       },
  //       {
  //         property: 'og:title',
  //         content: this.project_name_en + ',' + this.modelInfo.project_name_zh
  //       },
  //       {
  //         property: 'og:url',
  //         content: this.$route.path
  //       }
  //     ]
  //   }
  // },
  components: {
    detail,
    file,
    discuss,
    NewModel,
    NewDataset,
    NewCode,
    deployModel,
    deployAPI,
    newCp,
    Notice,
    PullRequests
  },
  data() {
    return {
      showBushuBtn: false,
      showBushuapiBtn:false,
      hasPer,
      modelVisible:false,
      loading: false,
      collectLoading: false,
      likeLoading: false,
      deleteLoading: false,
      newProjectVisible: false,
      bushuModelVisible: false,
      bushuAPIVisible: false,
      modelInfo: {},
      isEdit: false,
      activeTab: '',
      checkImg: {},
      checkapiImg:{},
      correlation: 0,
      apicorrelation:0,
      tabs: [
        {
          name: '详情',
          value: 'intro',
          logo: require('@/assets/images/model/detail.png')
        },
        {
          name: '文件',
          value: 'file',
          logo: require('@/assets/images/model/file.png')
        },
        {
          name: '讨论',
          value: 'discuss',
          logo: require('@/assets/images/model/discuss.png')
        },
        // {
        //   name: 'Pull Requests',
        //   value: 'PullRequests',
        //   logo: require('@/assets/images/model/discuss.png')
        // }
      ]
    }
  },
  computed: {
    project_name_en() {
      return this.$route.params.project_name_en
    },
    username_en() {
      return this.$route.params.username_en
    },
    tab() {
      return this.$route.params.tab || 'intro'
    },
    project_type() {
      return this.$store.state.project.type
    },
    project_type_name() {
      return this.project_type === 'M'
        ? '模型'
        : this.project_type === 'C'
        ? '代码'
        : '数据集'
    }
  },
  watch: {
    tab: {
      handler(val) {
        if (val) {
          this.activeTab = val
        }
      },
      immediate: true
    },
    $route: {
      handler(newVal, oldVal) {
        if (newVal.name === oldVal.name) {
          const { project_name_en, username_en } = newVal.params
          this.getProjectInfoById(username_en, project_name_en)
          this.activeTab = this.tab
        }
      },
      deep: true
    }
  },
  created() {
    this.getProjectInfoById(this.username_en, this.project_name_en)
  },
  mounted() {
    this.initClipboard()
  },
  methods: {
    closeDialog() {
      this.$refs.deployModelt.close()
    },
    // 复制git地址
    initClipboard() {
      const clipboard = new Clipboard('.copy-link')
      clipboard.on('success', (e) => {
        justOnceElMessage('success', '复制成功')
        e.clearSelection()
      })
      clipboard.on('error', (e) => {
        console.log(e)
        if (!e.text) {
          justOnceElMessage('warning', 'git地址不存在')
          return
        }
        justOnceElMessage('error', '复制失败')
      })
    },
    getProjectInfoById(username_en, project_name_en) {
      let project_type = this.$store.state.project.type
      this.modelInfo = {}
      this.loading = true
      this.$api.project
        .queryprojectinfo({
          group_name: username_en,
          project_name_en,
          project_type
        })
        .then((res) => {
          if (res.message === 'Success') {
            let {
              Id: id,
              project_name_zh,
              project_name_en,
              project_intro,
              project_category_id,
              project_git_url,
              content,
              update_at,
              is_train,
              creator,
              project_load_num,
              has_collect, // 是否收藏  1收藏 0未收藏
              has_like, // 是否点赞  1点赞 0未点赞
              username, // 创建者
              username_en, // 创建着
              user_id,
              wangpan_url,
              is_show_manage,
              issue_count,
              tuning_code_path
            } = res.data

            let tags = getProjectTags(res.data, this.project_type + 'D')

            update_at = dayjs(update_at).format('YYYY-MM-DD HH:mm:ss')

            let newContent = content
            if (content) {
              const contentArr = content.split('---\n')
              if (contentArr.length === 3) {
                // 去除--- ---包裹的分隔符部分
                if (contentArr[0] === '' || contentArr[0] === '\n') {
                  // --- --- 在开头
                  newContent = contentArr.slice(-1)
                } else if (contentArr[2] === '' || contentArr[2] === '\n') {
                  // --- --- 在结尾
                  newContent = contentArr.slice(0, 1)
                } else {
                  // --- --- 在中间
                  newContent = contentArr
                    .slice(0, 1)
                    .concat(contentArr.slice(-1))
                }
                newContent = newContent.join('')
              }
            }
            this.modelInfo = {
              id, // id
              project_name_zh, // 中文名
              project_name_en, // 英文名
              project_category_id, // 模型类型
              project_git_url, // 模型git地址
              project_intro, // 简介
              content: newContent, // 描述
              project_load_num, // 下载次数
              is_train, // 是否支持训练
              creator, // 创建者用户信息集合
              update_at, // 更新时间
              tags,
              has_collect,
              has_like,
              username,
              username_en,
              user_id,
              wangpan_url,
              is_show_manage,
              issue_count,
              tuning_code_path
            }
            this.getModelImages()
            this.getModelImagesapi()
            this.$store.dispatch('project/setProjectId', id)
          }else{
            this.$router.push('/no-permission')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getModelImages() {
      this.$api.project
        .getModelImages({
          project_model_id: this.modelInfo.id
        })
        .then((res) => {
          if (res.data.length > 0) {
            this.checkImg = res.data
            this.showBushuBtn = true
            this.correlation = res.data.length
            return
          }
        })
    },
    getModelImagesapi() {
      this.$api.project
        .getModelImagesapi({
          project_model_id: this.modelInfo.id
        })
        .then((res) => {
          if (res.data.length > 0) {
            this.checkapiImg = res.data
            this.showBushuapiBtn = true
            this.apicorrelation = res.data.length
            return
          }
        })
    },
    // 发布者点击
    ownerClick() {
      let params = {}
      if (this.modelInfo.user_id != 0) {
        // 组织
        this.$router.push('/organization/' + this.modelInfo.username_en)
      } else {
        params = {
          type: 'creator_id', // 参数名称
          id: this.modelInfo.creator.user_id, // 用户id
          name: this.modelInfo.creator.user_name // 用户name
        }
        this.tagClick(params)
      }
    },
    // 标签点击
    tagClick(item) {
      sessionStorage.setItem('queryprojectlist-params', JSON.stringify(item))
      this.$router.push({
        path:
          this.project_type === 'M'
            ? '/model'
            : this.project_type === 'C'
            ? '/codes'
            : '/dataset'
      })
    },
    newProject() {
      const pass = valiUser()
      if (pass) {
        this.isEdit = false
        this.newProjectVisible = true
      }
    },
    editPro() {
      this.isEdit = true
      this.newProjectVisible = true
      this.$nextTick(() => {
        const domName =
          this.project_type === 'M'
            ? 'newModelRef'
            : this.project_type === 'C'
            ? 'newCodeRef'
            : 'newDatasetRef'
        this.$refs[domName].isEditMode()
      })
    },
    finishFn() {
      this.bushuModelVisible = false
      this.$router.push({ path: '/spaces' })
    },
    APIfinishFn() {
      this.bushuAPIVisible = false
      this.$router.push({ path: '/api' })
    },
    deletePro() {
      this.$confirm(`确认删除${this.project_type_name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteLoading = true
        this.$api.project
          .delproject({
            project_id: this.modelInfo.id
          })
          .then((res) => {
            const { message } = res
            if (message === 'Success') {
              this.$message.success(`${this.project_type_name}删除成功`)
              this.$router.push({
                path: this.project_type === 'M' ? '/model' : '/dataset'
              })
            }
          })
          .finally(() => {
            this.deleteLoading = false
          })
      })
    },
    bushuModel() {
      const pass = valiUser()
      if (pass) {
        this.bushuModelVisible = true
        this.$nextTick(function () {
          if(this.checkImg.length==1){
              this.$refs.deployModelt.imageChange(this.checkImg[0],'image')
          }
          this.$refs.deployModelt.imagesSelect(this.checkImg[0])
        })
      }
    },
    bushuAPI() {
      const pass = valiUser()
      if (pass) {
        this.bushuAPIVisible = true
        this.$nextTick(function () {
          if(this.checkImg.length==1){
              this.$refs.deployAPI.imageChange(this.checkapiImg[0],'image')
          }
          this.$refs.deployAPI.imagesSelect(this.checkapiImg[0])
        })
      }
    },
    // 收藏
    collect() {
      if (!hasPer()) {
        // 未登录
        this.$store.dispatch('system/toLogin', true)
        return
      }
      let interfaceName = ''
      if (this.modelInfo.has_collect == 1) {
        // 已经收藏过
        interfaceName = 'projectcancelcollect'
      } else {
        // 未收藏
        interfaceName = 'projectcollect'
      }
      this.collectLoading = true
      this.$api.project[interfaceName]({
        project_id: this.modelInfo.id
      })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            this.getProjectInfoById(
              this.username_en,
              this.modelInfo.project_name_en
            )
          } else {
            this.$message.error(message)
          }
        })
        .finally(() => {
          this.collectLoading = false
        })
    },
    // 点赞
    like() {
      if (!hasPer()) {
        // 未登录
        this.$store.dispatch('system/toLogin', true)
        return
      }
      let interfaceName = ''
      if (this.modelInfo.has_like == 1) {
        // 已经收藏过
        interfaceName = 'projectcancelzan'
      } else {
        // 未收藏
        interfaceName = 'projectzan'
      }
      this.likeLoading = true
      this.$api.project[interfaceName]({
        project_id: this.modelInfo.id
      })
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            this.getProjectInfoById(
              this.username_en,
              this.modelInfo.project_name_en
            )
          } else {
            this.$message.error(message)
          }
        })
        .finally(() => {
          this.likeLoading = false
        })
    },
    newProjectVisibleFinish(data) {
      const { username, engName } = data
      this.newProjectVisible = false
      if (this.isEdit) {
        // 修改模式
        location.reload()
      } else {
        // 新增模式
        this.goDetail({ username, engName, tab: 'file' })
      }
    },
    goDetail(data) {
      const { username, engName, tab } = data
      let path =
        this.project_type === 'M'
          ? '/models'
          : this.project_type === 'C'
          ? '/codes'
          : '/datasets'
      this.$router.push(`${path}/${username}/${engName}/${tab}`)
    },
    //创建开发环境
    newmodeldev(){
      const pass = valiUser()
      if (pass) {
        this.modelVisible = true
        this.$nextTick(function () {
          this.$refs.newCp.train()
      })
      }
    },
    //开发环境创建成功
    modeldevfinish(e){
      this.modelVisible = false
      this.$router.push('/model-dev/'+e.username+'/envmanager/'+e.serving_name)
    },
    closeModel(){
      this.modelVisible = false
      this.$refs.newCp.close()
    }
  }
}
</script>

<style>

#app {
  height: 100%;
}

</style>

<style lang="scss" scoped>

.page-model-detail {
  .top {
    background: url('@/assets/images/model/model-detail-top-bg.png');
    background-size: 100% 100%;

    .download {
      background: url('@/assets/images/model/download_bg.png');
      background-size: 100% 100%;
    }

    .download-img {
      width: 16px;
      height: 16px;
    }

    .tab-icon {
      width: 19px;
      height: 19px;
      margin-right: 10px;
    }

    .like {
      background: #f4e9ff;
      border-radius: 3px;
      width: 53px;
      height: 53px;

      .like-icon {
        width: 16px;
        height: 16px;
      }
    }

    .tag {
      background: url('@/assets/images/model/tag_bg.png');
      background-size: 100% 100%;
    }

    .project_intro {
      font-size: 16px;
    }
  }
}

::v-deep {
  .el-tabs__header {
    margin-bottom: 0;

    .el-tabs__item {
      font-size: 21px;
      margin-bottom: 10px;
      width: 200px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .page-model-detail {
    .top {
      .download {
        display: none;
      }

      .tab-icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }

      .like {
        width: 80px;
        height: 80px;

        .like-icon {
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  .hide-x {
    display: none;
  }

  ::v-deep {
    .el-tabs__header {
      .el-tabs__item {
        margin-bottom: 60px;
        width: 400px;
      }
    }

    .el-table .cell {
      line-height: 100px;
    }
  }
}

</style>
